import React from "react";
import { HeartHandshake } from "lucide-react";
import { useApp } from "@/context/AppContext";
import { PRAYER_ACCENT, PRAYER_REACTIONS, fill } from "@/lib/prayers";

// « Je prie 🙏 » + ❤️ + Amen — one row, pill buttons, active state filled with the prayer accent.
export const PrayerReactions = ({ p, user, onPray, onReact, compact = false }) => {
  const { t } = useApp();
  const mine = new Set(p.my_reactions || []);
  const base = `rounded-full border inline-flex items-center gap-1 font-semibold transition-colors ${compact ? "h-8 px-2.5 text-xs" : "h-9 px-3 text-sm"}`;
  const style = (active) => (active
    ? { background: PRAYER_ACCENT, color: "#fff", borderColor: "transparent" }
    : { background: "transparent", color: "var(--yalola-text)", borderColor: "var(--yalola-border)" });
  return (
    <div className="flex items-center gap-1.5 flex-wrap" data-testid={`prayer-reactions-${p.id}`}>
      {p.is_mine ? (
        // Lot 660 : l'auteur ne prie pas pour sa propre demande → simple compteur
        <span className={base} style={{ background: "transparent", color: "var(--yalola-text-muted)", borderColor: "var(--yalola-border)", cursor: "default" }} data-testid={`prayer-pray-${p.id}`} data-mine="1" aria-disabled="true">
          <HeartHandshake size={compact ? 13 : 15} />
          {fill(t("prayers.praying_for_you", "{n} prient pour toi"), { n: p.pray_count || 0 })}
        </span>
      ) : (
      <button
        type="button"
        className={base}
        style={style(p.prayed_by_me)}
        onClick={(e) => { e.stopPropagation(); onPray?.(p); }}
        disabled={!user}
        aria-pressed={!!p.prayed_by_me}
        data-testid={`prayer-pray-${p.id}`}
      >
        <HeartHandshake size={compact ? 13 : 15} />
        {p.prayed_by_me ? t("prayers.praying", "Je prie 🙏") : t("prayers.pray", "Je prie")}
        {p.pray_count > 0 && <span className="ml-0.5 tabular-nums" data-testid={`prayer-pray-count-${p.id}`}>{p.pray_count}</span>}
      </button>
      )}
      {PRAYER_REACTIONS.map((r) => {
        const n = Number(p.reactions?.[r.type]) || 0;
        const active = mine.has(r.type);
        return (
          <button
            key={r.type}
            type="button"
            className={base}
            style={style(active)}
            onClick={(e) => { e.stopPropagation(); onReact?.(p, r.type); }}
            disabled={!user}
            aria-pressed={active}
            title={r.tKey ? t(r.tKey, r.fb) : r.emoji}
            data-testid={`prayer-react-${r.type}-${p.id}`}
            data-active={active ? "1" : "0"}
          >
            <span aria-hidden>{r.emoji}</span>
            {r.tKey && <span>{t(r.tKey, r.fb)}</span>}
            {n > 0 && <span className="ml-0.5 tabular-nums" data-testid={`prayer-react-${r.type}-count-${p.id}`}>{n}</span>}
          </button>
        );
      })}
    </div>
  );
};
